<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer002">
<p class="pl-header"><span class="bold">Praise for the authors of</span> Convenient Christmas Brides </p>
<p class="pl-center-bold">CARLA KELLY </p>
<p class="pl-epigraph">“A lovely, whimsical tale with unforgettable characters and richly detailed prose.”</p>
<p class="pl-citation">—<em class="italic">RT Book Reviews</em> on “Captain Grey’s Christmas Proposal” in <em class="italic">Regency Christmas Wishes</em></p>
<p class="pl-center-bold">LOUISE ALLEN </p>
<p class="pl-epigraph">“Allen writes Regency romances that always become favorites.”</p>
<p class="pl-citation">—<em class="italic">RT Book Reviews</em> on <em class="italic">The Earl’s Practical Marriage</em></p>
<p class="pl-center-bold">LAURIE BENSON</p>
<p class="pl-epigraph">“Delightfully unexpected plot twists, with lively dialogue and witty repartee.... A charmer.”</p>
<p class="pl-citation">—<em class="italic">RT Book Reviews</em> on <em class="italic">The Unexpected Countess </em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Praise.vue?78bd4a5b